import { ReactNode } from 'react'
import classNames from 'classnames'
import { FlexColumn, FlexRow } from '@/atoms/FlexContainers'
import { Image } from '@/atoms/Image'
import { HeadingSM, TitleLG } from '@/atoms/Text'

interface ExplainerSectionProps {
  background?: string
  button?: ReactNode
  content: ReactNode
  icon: ReactNode
  image: string
  reverse?: boolean
  subtitle?: string
  title: string
}

export const ExplainerSection: React.FC<ExplainerSectionProps> = ({
  background = 'bg-core-gray-950',
  button,
  content,
  icon,
  image,
  reverse = false,
  subtitle,
  title,
}) => {
  return (
    <section className={classNames('w-full py-[72px]', background)}>
      <div className="px-8 md:mx-auto md:w-[693px] md:px-0 xl:mx-16 xl:w-fit 2xl:mx-auto 2xl:w-full">
        <div
          className={classNames('flex flex-col gap-[72px] xl:flex-row xl:max-w-[1558px] xl:mx-auto', {
            'xl:flex-row-reverse': reverse,
          })}
        >
          <div className="relative mx-auto h-[228px] w-full overflow-hidden rounded-2xl md:h-[400px] md:w-full xl:h-[580px] xl:basis-1/2 2xl:h-[663px]">
            <Image alt={title} fill className="object-cover" src={image} />
          </div>
          <FlexColumn className="gap-8 xl:my-auto xl:basis-1/2">
            <FlexRow className="gap-4">
              {icon}
              <HeadingSM weight="bold">{title}</HeadingSM>
            </FlexRow>
            <FlexColumn className="gap-2">
              {subtitle && <TitleLG weight="bold">{subtitle}</TitleLG>}
              {content}
            </FlexColumn>
            {button}
          </FlexColumn>
        </div>
      </div>
    </section>
  )
}
